import * as types from "./actions";

export function setRenderSide(data) {
  // console.log("Hello iam calll", data);
  return {
    type: types.RENDERSIDEBAR,
    payload: data,
  };
}

export function setRenderHeader(data) {
  // console.log("Hello iam calll", data);
  return {
    type: types.RENDERHEADER,
    payload: data,
  };
}
